import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { DynamicPanel, GroupPanel } from '../../interfaces';
import { ServiceAgent } from 'src/app/framework-modules/formdata/form/serviceAgent';
import { CtTableComponent, TableMetaData, } from '../../../../framework-modules/elements/ct-table/component'
import { FilterRequest } from 'src/app/framework-modules/formdata/form/types';
import { SessionComponent } from '../../component';
import { CtSpinner } from 'src/app/framework-modules/elements/ct-spinner/component';
import { PacketListForm, PacketListVo } from 'src/app/framework-modules/formdata/gen/packetListForm';
import { PanelData } from 'src/app/framework-modules/formdata/form/formData';
import { MessageService } from 'src/app/services/messageService';
import { EvaluatorSelectionForm, EvaluatorSelectionFd } from 'src/app/framework-modules/formdata/gen/evaluatorSelectionForm';
import { PacketSearchFd, PacketSearchForm } from "src/app/framework-modules/formdata/gen/packetSearchForm";


@Component({
  selector: "packet-list-search",
  templateUrl: "./component.html",
  styleUrls: ["./component.scss"]
})

export class PacketListSearchComponent implements DynamicPanel, OnInit {
  @ViewChild("gridTable", { static: false }) gtable: CtTableComponent;
  @ViewChild("spinner", { static: false }) public spinner: CtSpinner;
  @Input() inputData: any;
  @Input() parentPanel: GroupPanel;
  @Input() session: SessionComponent;
  public form: PacketSearchForm;
  public fd: PacketSearchFd;
  public tableData: TableMetaData;

  private pd: PanelData;
  private packets: PacketListVo[];


  constructor(private sa: ServiceAgent, private ms: MessageService) {
    this.form = PacketSearchForm.getInstance();
    this.fd = this.form.newFormData(this.sa);

    this.pd = PacketListForm.getInstance().newPanelData(this.sa);
  }


  ngOnInit() {
    this.metaDataInit();
  }

  metaDataInit() {
    this.tableData = {
      data: [],
      metaData: {
        column_names: [
          "packetCode",
          "name",
          "phoneNumber"
        ],
        display_names: {
          packetCode: "Packet",
          name: "Evaluator Name",
          phoneNumber: "Phone Number"
        },
        search: true,
        edit:true,
        view:true,
        buttonName:"Enter Marks",
        placeholder: "Search By Evaluator Name, Packet ID....",
      }
    };
  }

  public searchForPackets() {
    var code = (this.fd.getFieldValue('packetCode') as string).trim().toUpperCase();
    if (!code || code == "") {
      this.ms.showError('Invalid Packet Code');
      return;
    }
    this.fd.setFieldValue("packetCode",code);
    const filter: FilterRequest = {
      conditions: { packetCode: { comp: "~", value: code } }
    };
    this.getData(filter);
  }

  /**
   * get list of packets for this offer-id. PacketListForm is used
   * @param offerId 
   */
  private getData(filter) {
    this.spinner.show('Getting packets ..')
    this.pd.filter(filter).subscribe({
      next: list => {
        console.log(list.length + ' packets');
        this.tableData.data = list;
        this.packets = list;
        this.gtable.update(this.spinner);
      },
      error: msgs => {
        this.spinner.hide();
        this.ms.showError('Server returned with errors..');
      }
    });
  }

  private getParams(idx) {
    const vo = this.packets[idx];
    return { 
      offeredSubjectId: vo.offeredSubjectId, 
      packetCode: vo.packetCode,
      isMakeUp: false
    };
  }
  public editPacket(idx) {
    this.parentPanel.navigate('ValuationEdit', {data: this.getParams(idx), screen: "PacketListSearch"});
  }
  public viewPacket(idx) {
    this.parentPanel.navigate('ValuationView', {data: this.getParams(idx), screen: "PacketListSearch"});
  }
}
